import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from '../services/apiClient';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const login = useCallback(async (emailUser, senha) => {
    try {
      const response = await api.post('/login', {
        username: emailUser,
        senha,
      });

      const { id, name, tipoUsuario, email, nome, apelido, telefone, token } = response.data;
      const tipoUsuarioInt = parseInt(tipoUsuario, 10);

      setUser({ id, name, tipoUsuario: tipoUsuarioInt, email, nome, apelido, telefone, token });
      localStorage.setItem('creadXToken', token);
      return true;
    } catch (error) {
      console.log('Login failed:', error);
      return false;
    }
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    localStorage.removeItem('creadXToken');
    window.location.href = '/';
  }, []);

  const checkAuthentication = useCallback(async () => {
    const authToken = localStorage.getItem('creadXToken');

    if (authToken) {
      try {
        const response = await api.get('/user', {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        const { id, name, tipoUsuario, email, nome, apelido, telefone, token } = response.data;
        const tipoUsuarioInt = parseInt(tipoUsuario, 10);

        setUser({ id, name, tipoUsuario: tipoUsuarioInt, email, nome, apelido, telefone, token });
      } catch (error) {
        console.error('Erro ao verificar autenticação', error);
        logout();
      }
    }
  }, [logout]);

  useEffect(() => {
    checkAuthentication();
  }, [checkAuthentication]);

  const isAuthenticated = useCallback(() => !!user, [user]);

  const isAdmin = useCallback(() => !!user && user.tipoUsuario === 0, [user]); // Modificado para checar o tipoUsuario

  const hasPermission = useCallback(
    (permission) => {
      console.log('permission', permission);
      switch (permission) {
        case 'admin':
          return isAdmin();
        default:
          return false;
      }
    },
    [isAdmin]
  );

  return <AuthContext.Provider value={{ user, login, logout, isAuthenticated, isAdmin, hasPermission }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
